import React, { useState } from 'react'
import axios from 'axios'

const DownloadFormData = () => {
    const [password, setPassword] = useState('')
    const [authenticated, setAuthenticated] = useState(false)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [rows, setRows] = useState([])

    const expectedPassword = '!password@3096'
    const apiUrl = 'https://admissions.swec.ac.in/api/jee/jee-admissions'
    // const apiUrl = 'http://localhost:5000/api/jee/jee-admissions'

    const handlePasswordSubmit = async (event) => {
        event.preventDefault()
        setError('')

        if (password !== expectedPassword) {
            setError('Invalid password. Please try again.')
            return
        }

        setLoading(true)
        try {
            const response = await axios.get(apiUrl)
            const data = response.data
            setRows(Array.isArray(data) ? data : [])
            setAuthenticated(true)
        } catch (fetchError) {
            setError('Unable to load admission data. Please check the server and try again.')
        } finally {
            setLoading(false)
        }
    }

    const downloadCsv = () => {
        const filteredRows = rows
            .filter((row) => Number(row.id) > 60)
            .map((row) => {
                const normalizedRow = { ...row }
                const urlFields = [
                    'photo',
                    'sscMemo',
                    'interMemo',
                    'jeeRankCard',
                    'tgeapcetRankCard',
                    'applicantSignature',
                    'parentSignature',
                ]

                for (const field of urlFields) {
                    if (typeof normalizedRow[field] === 'string') {
                        normalizedRow[field] = normalizedRow[field]
                            .replace('C:/inetpub/Admissions_swec', 'https://admissions.swec.ac.in')
                            .replace('C:\\inetpub\\Admissions_swec', 'https://admissions.swec.ac.in')
                    }
                }

                return normalizedRow
            })

        if (!filteredRows.length) {
            setError('No records with id > 60 were available for download.')
            return
        }

        const headers = Object.keys(filteredRows[0])
        const csvRows = [headers.join(',')]

        for (const row of filteredRows) {
            const values = headers.map((header) => {
                const value = row[header] ?? ''
                const escaped = String(value).replace(/"/g, '""')
                return `"${escaped}"`
            })
            csvRows.push(values.join(','))
        }

        const csvData = csvRows.join('\r\n')
        const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'jee_admissions.csv')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
    }

    return (
        <div style={{ padding: '24px', maxWidth: '420px', margin: '0 auto', fontFamily: 'sans-serif' }}>
            {!authenticated ? (
                <form onSubmit={handlePasswordSubmit}>
                    <h2>Protected Download</h2>
                    <p>Enter the page password to load the admission data.</p>
                    <label htmlFor="download-password" style={{ display: 'block', marginBottom: '8px' }}>
                        Password
                    </label>
                    <input
                        id="download-password"
                        type="password"
                        value={password}
                        onChange={(event) => setPassword(event.target.value)}
                        style={{ width: '100%', padding: '10px', marginBottom: '12px', boxSizing: 'border-box' }}
                        placeholder="Enter password"
                    />
                    <button
                        type="submit"
                        style={{ width: '100%', padding: '10px', cursor: 'pointer' }}
                        disabled={loading}
                    >
                        {loading ? 'Checking...' : 'Unlock and Load Data'}
                    </button>
                    {error && (
                        <p style={{ color: '#c00', marginTop: '12px' }}>{error}</p>
                    )}
                </form>
            ) : (
                <div style={{ textAlign: 'center' }}>
                    {loading ? (
                        <p>Loading admission data...</p>
                    ) : (
                        <button
                            type="button"
                            onClick={downloadCsv}
                            style={{ padding: '12px 24px', cursor: 'pointer' }}
                        >
                            Download CSV
                        </button>
                    )}
                    {!rows.length && !loading && (
                        <p style={{ marginTop: '12px' }}>No admission records were returned.</p>
                    )}
                </div>
            )}
        </div>
    )
}

export default DownloadFormData